/**
 * useBackClose — 안드로이드 뒤로가기(BackGuard)로 이 팝업/오버레이가 닫히도록 등록.
 * PopupShell 을 쓰지 않는 커스텀 오버레이(로그인/회원가입/프로필/1:1채팅/위젯 등)에서 사용.
 * 마운트 시 modalStack 에 close 를 1회 등록(최신 onClose 를 ref 로 항상 참조),
 * 언마운트 시 해제. → 뒤로가기 1회 = 최상위 팝업 닫기 (다른 PopupShell 모달과 동일 동작).
 */
import { useEffect, useRef } from "react";
import { registerModalClose } from "../utils/modalStack";

export function useBackClose(onClose: () => void) {
  const ref = useRef(onClose);
  ref.current = onClose;
  useEffect(() => {
    const unregister = registerModalClose(() => ref.current());
    return () => unregister();
  }, []);
}
